import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  document: Yup.string().required('documentCard.required'),
});

export default validationSchema;
